import { render, staticRenderFns } from "./CompletionScreenDefault.vue?vue&type=template&id=4f0df255&scoped=true&"
import script from "./CompletionScreenDefault.vue?vue&type=script&lang=js&"
export * from "./CompletionScreenDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0df255",
  null
  
)

export default component.exports